import { Navigate } from 'react-router-dom';

const WORKSPACE_ROLES = new Set(['company_admin', 'company_manager', 'company_staff']);

const WorkspaceRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace state={{ from: '/workspace' }} />;
  }

  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const role = String(user?.role || '');
    if (WORKSPACE_ROLES.has(role)) {
      return children;
    }
    // Guest users → meeting private workspace; others → host dashboard
    if (role === 'guest') {
      return <Navigate to="/meetings/workspace" replace />;
    }
    return <Navigate to="/host" replace />;
  } catch {
    return <Navigate to="/login" replace />;
  }
};

export default WorkspaceRoute;
